import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DiscountModel } from '../model/discount.model';
import { DiscountService } from '../discount.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { MatTableDataSource } from '@angular/material/table';
import { SaleItemService } from 'src/app/pages/common/products/sale-item/sale-item.service';
import { SaleItemDiscountDialogComponent } from './sale-item-discount-dialog/sale-item-discount-dialog.component';
import { SaleItemDeleteConformationDialogComponent } from './sale-item-delete-conformation-dialog/sale-item-delete-conformation-dialog.component';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
    selector: 'app-discount-edit',
    templateUrl: './discount-edit.component.html',
    styleUrls: ['./discount-edit.component.scss'],
    standalone: false
})
export class DiscountEditComponent implements OnInit, DirtyCheck {

    title: string = "New Discount";
    editForm: FormGroup;
    //discountInfo: DiscountModel = {};
    discountInfo: DiscountModel = { sale_item: [] };
    isFormDirty: boolean = false;
    displayedColumns = ["sale_item_code", "sale_item_name", "price", "delete"];
    daysOfWeek: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    hours: string[] = Array.from({ length: 24 }, (_, i) =>
        i.toString().padStart(2, "0")
    );
    minutes: string[] = Array.from({ length: 60 }, (_, i) =>
        i.toString().padStart(2, "0")
    );
    time_from_hour: any;
    time_from_minute: any;
    time_to_hour: any;
    time_to_minute: any;
    // dataSource: any[] = [];
    dataSource = new MatTableDataSource(this.discountInfo.sale_item);
    saleitemList: DiscountModel[] = [];
    allItemList: DiscountModel[] = [];
    permission: any;



    constructor(private router: Router,
        private builder: FormBuilder,
        private route: ActivatedRoute,
        private discountService: DiscountService,
        private snackBarService: SnackBarService,
        public dialog: MatDialog,
        private permissionService: PermissionService,
        private saleItemService: SaleItemService
    ) {

        let discountId = this.route.snapshot.paramMap.get('id');
        this.editForm = this.builder.group({
            code: this.builder.control(this.discountInfo.code, [Validators.required, Validators.maxLength(10)]),
            name: this.builder.control(this.discountInfo.name, [Validators.required, Validators.maxLength(100)]),
            description: this.builder.control(this.discountInfo.description, [Validators.maxLength(500)]),
            is_percentage: this.builder.control(this.discountInfo.is_percentage !== undefined ? Number(this.discountInfo.is_percentage) : 0),
            is_overridable: this.builder.control(
                this.discountInfo.is_overridable !== undefined ? Number(this.discountInfo.is_overridable) : 0
            ),
            is_change_payable: this.builder.control(
                this.discountInfo.is_change_payable !== undefined ? Number(this.discountInfo.is_change_payable) : 0
            ),
            is_valid: this.builder.control(this.discountInfo.is_valid !== undefined ? Number(this.discountInfo.is_valid) : 0),
            is_promotion: this.builder.control(
                this.discountInfo.is_promotion !== undefined ? Number(this.discountInfo.is_promotion) : 0
            ),
            permitted_for: this.builder.control(this.discountInfo.permitted_for !== undefined ? this.discountInfo.permitted_for : 1, [
                Validators.required,
            ]),
            allow_editing: this.builder.control(this.discountInfo.allow_editing !== undefined ? this.discountInfo.allow_editing : 0, [
                Validators.required,
            ]),
            bg_color: this.builder.control(this.discountInfo.bg_color),
            fg_color: this.builder.control(this.discountInfo.fg_color),
            account_code: this.builder.control(this.discountInfo.account_code),
            is_item_specific: this.builder.control(
                this.discountInfo.is_item_specific !== undefined ? Number(this.discountInfo.is_item_specific) : 0
            ),
            price: this.builder.control(this.discountInfo.price),
            // is_percentage: this.builder.control(this.discountInfo.is_percentage || 0),
            grouping_quantity: this.builder.control(
                this.discountInfo.grouping_quantity
            ),
            date_to: this.builder.control(this.discountInfo.date_to),
            date_from: this.builder.control(this.discountInfo.date_from),
            time_from_hour: this.builder.control(
                this.parseTime(this.discountInfo?.time_from)?.hour || "00"
            ),
            time_from_minute: this.builder.control(
                this.parseTime(this.discountInfo?.time_from)?.minute || "00"
            ),
            time_to_hour: this.builder.control(
                this.parseTime(this.discountInfo?.time_to)?.hour || "00"
            ),
            time_to_minute: this.builder.control(
                this.parseTime(this.discountInfo?.time_to)?.minute || "00"
            ),
            week_days: this.builder.group({}),
        });

        this.editForm.valueChanges.subscribe(() => {
            this.isFormDirty = true;
        });

        // Subscribe to allow_editing changes to update price validation
        this.editForm.get('allow_editing')?.valueChanges.subscribe((value) => {
            this.updatePriceValidation(value);
        });

        // Subscribe to permitted_for changes to update is_item_specific state and price validation
        this.editForm.get('permitted_for')?.valueChanges.subscribe((value) => {
            this.updateItemSpecificState(value);
            this.updatePriceValidation();
        });

        // Subscribe to is_item_specific changes to update price validation
        this.editForm.get('is_item_specific')?.valueChanges.subscribe((value) => {
            this.updatePriceValidation();
        });

        // Initial validation setup
        this.updatePriceValidation(this.editForm.get('allow_editing')?.value);
        this.updateItemSpecificState(this.editForm.get('permitted_for')?.value);

        if (discountId !== null && parseInt(discountId) !== 0) {
            this.setDiscountInfo(discountId);
        }
        const weekDaysGroup = this.editForm.get("week_days") as FormGroup;

        const selectedWeekDays =
            this.discountInfo.week_days?.split(",").map((day) => day.toLowerCase()) ||
            [];

        this.daysOfWeek.forEach((day) => {
            const lowercaseDay = day.toLowerCase().slice(0, 3); // Convert 'Wed' → 'wed'
            const isChecked = selectedWeekDays.includes(lowercaseDay);
            weekDaysGroup.addControl(day, new FormControl(isChecked));
        });
        this.permission = permissionService.getPagePermission("discount");

    }

    ngOnInit(): void {
        this.loadItemsData();
    }

    isDirty(): boolean {
        return this.isFormDirty;
    }

    /**
     * Update price field validation based on is_item_specific and allow_editing values
     * Price field is mandatory when: is_item_specific is false AND allow_editing is "None" (0)
     * Price field is optional in all other cases
     * When discount field is hidden, set its value to 0
     */
    updatePriceValidation(allowEditingValue?: number): void {
        const priceControl = this.editForm.get('price');
        const isItemSpecificValue = this.editForm.get('is_item_specific')?.value;
        const permittedForValue = this.editForm.get('permitted_for')?.value;

        if (priceControl) {
            // Get current allow_editing value if not provided
            const currentAllowEditing = allowEditingValue !== undefined ? allowEditingValue : this.editForm.get('allow_editing')?.value;

            // Check if discount field should be hidden
            const shouldHideForItemSpecific = isItemSpecificValue === 1 && permittedForValue === 1;
            const shouldHideForAllowEditing = currentAllowEditing !== 0 && permittedForValue === 1;

            if (shouldHideForItemSpecific || shouldHideForAllowEditing) {
                // When discount field is hidden, set value to 0 and clear validators
                priceControl.setValue(0);
                priceControl.clearValidators();
            } else {
                // Make price mandatory only when is_item_specific is false (0) AND allow_editing is "None" (0)
                if (!isItemSpecificValue && currentAllowEditing === 0) {
                    priceControl.setValidators([Validators.required]);
                } else {
                    // Clear validators in all other cases
                    priceControl.clearValidators();
                }
            }
            priceControl.updateValueAndValidity();
        }
    }

    /**
     * Update is_item_specific field state based on permitted_for value
     * When permitted_for is 2 (Bill Discount), is_item_specific should be set to false
     * When permitted_for is 1 (Item Discount), is_item_specific can be freely changed
     * Also clear promotion field when permitted_for is 2
     */
    updateItemSpecificState(permittedForValue: number): void {
        const itemSpecificControl = this.editForm.get('is_item_specific');
        const promotionControl = this.editForm.get('is_promotion');

        if (itemSpecificControl) {
            if (permittedForValue === 2) {
                // When permitted_for is "Bill Discount", set is_item_specific to false
                itemSpecificControl.setValue(0);
                // Also clear promotion field when Bill Discount is selected
                if (promotionControl) {
                    promotionControl.setValue(0);
                }
            }
            // Checkbox remains enabled and can be freely changed by user
        }
    }

    // Parse time string (e.g., "14:30:00") into hour and minute
    parseTime(
        time: string | null | undefined
    ): { hour: string; minute: string } | null {
        if (!time) return null;
        const [hour, minute] = time.split(":");
        return { hour: hour || "00", minute: minute || "00" };
    }

    navBack(): void {
        this.router.navigate(['/promotion/discount']);
    }

    loadItemsData(): void {
        let requestData = {
            search: {
                filters: {
                    simpleSearch: [],
                    advSearch: [],
                    scope: { limit: 10000, offset: 0 },
                },
                sort: [{ column: "sale_items.name", order: "asc" }],
            },
        };
        let response = this.saleItemService
            .getList(requestData)
            .subscribe((response) => {
                if (response.status == "SUCCESS") {
                    this.allItemList = response.data.items;

                    console.log(this.allItemList);
                    // this.setDataSource(response.data.item_classes);
                } else {
                    let snackBarData: SnackBarData = {
                        message: response.message,
                        title: "Failed!!!",
                        type: "error",
                    };
                    this.snackBarService.openSnackBar(snackBarData);
                }
            });
    }

    openSaleItemBrowseDialog(): void {
        const discountId = this.discountInfo?.id;
        var filtertedItemList = this.allItemList;

        if (
            this.discountInfo.sale_item !== null &&
            this.discountInfo.sale_item !== undefined
        ) {
            filtertedItemList = this.allItemList.filter(
                (asi: any) =>
                    !this.discountInfo.sale_item?.some(
                        (csi: any) => String(csi.sale_item_id) === String(asi.id)
                    )
            );
        }

        const editorConfig = {
            // title: "Rewards",
            items: filtertedItemList,
            discountId: discountId,
            // selectedItemId: this.saleItemInfo.id,
        };

        const dialogRef = this.dialog.open(SaleItemDiscountDialogComponent, {
            width: "30%",
            height: "80%", // Adjust the diamensions as needed
            data: editorConfig,
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
                const selectedItems = result.selectedItems; // Store selected items in the component property
                if (
                    this.discountInfo !== undefined &&
                    this.discountInfo.sale_item !== undefined
                ) {
                    selectedItems.forEach((ssi: any) => {
                        if (
                            !this.discountInfo.sale_item?.some(
                                (csi: any) => csi.sale_item_id === ssi.sale_item_id
                            )
                        ) {
                            this.discountInfo.sale_item?.push(ssi);
                        }
                    });
                } else {
                    this.discountInfo.sale_item = selectedItems;
                }
                this.dataSource.data = this.discountInfo.sale_item ?? [];
                // console.log(this.dataSource.data)
                console.log(selectedItems);
                console.log(this.dataSource.data);
            }
        });
    }

    setDiscountInfo(discountId: any): void {
        let response = this.discountService.getDiscountById(discountId).subscribe({
            next: (response) => {
                if (response.status == 'SUCCESS') {
                    this.discountInfo = response.data.discount;

                    this.discountInfo.sale_item = response.data.items;
                    this.dataSource.data = this.discountInfo.sale_item ?? [];
                    const weekDaysString = this.discountInfo.week_days || "";
                    const selectedDays = weekDaysString.toLowerCase().split(",");
                    const weekDaysValue: { [key: string]: boolean } = {};

                    this.daysOfWeek.forEach((day) => {
                        const dayKey = day;
                        const dayLower = day.toLowerCase().substring(0, 3); // e.g., 'Thu' → 'thu'
                        weekDaysValue[dayKey] = selectedDays.includes(dayLower);
                    });

                    // Patch the form with the processed week_days
                    this.editForm.patchValue({
                        ...this.discountInfo,
                        week_days: weekDaysValue,
                        permitted_for: this.discountInfo.permitted_for !== undefined ? Number(this.discountInfo.permitted_for) : 1,
                        allow_editing: this.discountInfo.allow_editing !== undefined ? Number(this.discountInfo.allow_editing) : 0,
                        is_percentage: this.discountInfo.is_percentage !== undefined ? Number(this.discountInfo.is_percentage) : 0,
                        is_overridable: this.discountInfo.is_overridable !== undefined ? Number(this.discountInfo.is_overridable) : 0,
                        is_change_payable: this.discountInfo.is_change_payable !== undefined ? Number(this.discountInfo.is_change_payable) : 0,
                        is_valid: this.discountInfo.is_valid !== undefined ? Number(this.discountInfo.is_valid) : 0,
                        is_promotion: this.discountInfo.is_promotion !== undefined ? Number(this.discountInfo.is_promotion) : 0,
                        is_item_specific: this.discountInfo.is_item_specific !== undefined ? Number(this.discountInfo.is_item_specific) : 0,
                        // Include existing time_from and time_to processing here
                    });

                    if (this.discountInfo.time_from) {
                        const [fromHour, fromMinute] =
                            this.discountInfo.time_from.split(":");
                        this.editForm
                            .get("time_from_hour")
                            ?.setValue(fromHour.padStart(2, "0"));
                        this.editForm
                            .get("time_from_minute")
                            ?.setValue(fromMinute.padStart(2, "0"));
                    }

                    if (this.discountInfo.time_to) {
                        const [toHour, toMinute] = this.discountInfo.time_to.split(":");
                        this.editForm
                            .get("time_to_hour")
                            ?.setValue(toHour.padStart(2, "0"));
                        this.editForm
                            .get("time_to_minute")
                            ?.setValue(toMinute.padStart(2, "0"));
                    }

                    // Update price validation based on allow_editing value
                    this.updatePriceValidation(this.discountInfo.allow_editing !== undefined ? Number(this.discountInfo.allow_editing) : 0);

                    // Update item specific state based on permitted_for value
                    this.updateItemSpecificState(this.discountInfo.permitted_for !== undefined ? Number(this.discountInfo.permitted_for) : 1);

                    this.title = this.getTitle();
                    this.isFormDirty = false;
                } else {
                    let snackBarData: SnackBarData = {
                        message: response.message,
                        title: "Failed!!!",
                        type: "error",
                    };
                    this.snackBarService.openSnackBar(snackBarData);
                }
            },
            error: (error) => {
                let snackBarData: SnackBarData = {
                    message: "Failed to get data from server.",
                    title: "Failed!!!",
                    type: "error",
                };
                this.snackBarService.openSnackBar(snackBarData);
            },
        });
    }

    getTitle(): string {
        let title = (this.discountInfo.id == 0) ? "New Discount" : "Editing : " + this.discountInfo.name;
        return title;
    }
    onDeleteSaleItem(saleItemId: number): void {
        const discountId = this.discountInfo.id;

        if (!discountId) {
            console.error("Discount ID is missing");
            return;
        }

        // Find the item to get its name
        const item = this.dataSource.data.find(
            (item) => item.sale_item_id === saleItemId
        );

        if (!item) {
            this.showSnackbar("Item not found", "error");
            return;
        }

        // Open the dialog
        const dialogRef = this.dialog.open(
            SaleItemDeleteConformationDialogComponent,
            {
                width: "400px",
                data: { sale_item_name: item.sale_item_name },
            }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                // User confirmed deletion
                if (discountId > 0) {
                    // For existing discounts: call API to delete from database
                    this.discountService
                        .deleteSaleItemDiscount(discountId, saleItemId)
                        .subscribe({
                            next: (response) => {
                                if (response.status === "SUCCESS") {
                                    this.removeItemFromDataSource(saleItemId);
                                    this.showSnackbar("Item removed successfully", "success");
                                } else {
                                    this.showSnackbar(
                                        "Failed to remove item: " + response.message,
                                        "error"
                                    );
                                }
                            },
                            error: (err: any) => {
                                this.showSnackbar(
                                    "Error removing item: " + err.message,
                                    "error"
                                );
                            },
                        });
                } else {
                    // For new discounts (not saved yet): just remove from local array
                    this.removeItemFromDataSource(saleItemId);
                    this.showSnackbar("Item removed from discount", "success");
                }
            }
        });
    }




    /**
       * On save
       * if the details are valid call the api to update the changes.
       */
    save(): void {
        const hasInvalidDiscounts = this.dataSource.data.some(
            (item) => !this.isDiscountValid(item.price)
        );

        // Check if is_item_specific is checked but no items are added
        const isItemSpecificChecked = this.editForm.value.is_item_specific;
        const hasNoItems = !this.dataSource.data || this.dataSource.data.length === 0;

        if (isItemSpecificChecked && hasNoItems) {
            const snackBarData: SnackBarData = {
                message: "Please add any of the item from the list when Item Specific is selected",
                title: "Items Required",
                type: "error",
            };
            this.snackBarService.openSnackBar(snackBarData);
            this.editForm.markAllAsTouched();
            return; // Prevent form submission
        }

        // Check if time from is before time to when promotion is enabled
        const isPromotionEnabled = this.editForm.value.is_promotion;
        if (isPromotionEnabled) {
            const timeFromHour = parseInt(this.editForm.value.time_from_hour || '0');
            const timeFromMinute = parseInt(this.editForm.value.time_from_minute || '0');
            const timeToHour = parseInt(this.editForm.value.time_to_hour || '0');
            const timeToMinute = parseInt(this.editForm.value.time_to_minute || '0');

            // Convert to minutes for easier comparison
            const timeFromInMinutes = timeFromHour * 60 + timeFromMinute;
            const timeToInMinutes = timeToHour * 60 + timeToMinute;

            if (timeFromInMinutes >= timeToInMinutes) {
                const snackBarData: SnackBarData = {
                    message: "The Time From should be earlier than the Time To.",
                    title: "Invalid Time Range",
                    type: "error",
                };
                this.snackBarService.openSnackBar(snackBarData);
                this.editForm.markAllAsTouched();
                return; // Prevent form submission
            }
        }

        console.log(this.editForm);
        if (this.editForm.valid && !hasInvalidDiscounts) {
            this.editForm.markAllAsTouched();
            // Object.assign(this.voucherInfo, this.editForm.value);
            // Create a copy of the form value and format time_from and time_to
            const formattedDiscountInfo = {
                ...this.editForm.value,
                time_from: this.getFormattedTime("time_from"),
                time_to: this.getFormattedTime("time_to"),
                week_days: this.getSelectedDays(),
                // Convert boolean values to numbers for backend compatibility
                is_percentage: this.editForm.value.is_percentage ? 1 : 0,
                is_overridable: this.editForm.value.is_overridable ? 1 : 0,
                is_change_payable: this.editForm.value.is_change_payable ? 1 : 0,
                is_valid: this.editForm.value.is_valid ? 1 : 0,
                is_promotion: this.editForm.value.is_promotion ? 1 : 0,
                is_item_specific: this.editForm.value.is_item_specific ? 1 : 0,
            };
            if (!formattedDiscountInfo.is_item_specific) {
                formattedDiscountInfo.sale_item = [];
            }
            // Update voucherInfo with formatted values
            Object.assign(this.discountInfo, formattedDiscountInfo);
            // console.log(this.discountInfo);
            this.discountService.update(this.discountInfo).subscribe({
                next: (response) => {

                    if (response.status == "SUCCESS") {
                        // handle success
                        this.isFormDirty = false;
                        let snckBarData: SnackBarData = {
                            type: "success",
                            title: "Saved",
                            message:
                                "The record for " +
                                this.discountInfo.name +
                                " has been updated succesfully.",
                        };
                        this.snackBarService.openSnackBar(snckBarData);
                        this.router.navigate(["/promotion/discount"]);
                    } else {
                        let snackBarData: SnackBarData = {
                            message: response.message,
                            title: "Failed!!!",
                            type: "error",
                        };
                        this.snackBarService.openSnackBar(snackBarData);

                    }
                },
                error: (error) => {
                    // handle error
                    let snackBarData: SnackBarData = {
                        message: "Failed to update. Connection to the server failed",
                        title: "Failed!!!",
                        type: "error",
                    };
                    this.snackBarService.openSnackBar(snackBarData);
                },
            });
        } else {
            if (hasInvalidDiscounts) {
                const snackBarData: SnackBarData = {
                    message: "Please enter valid  numbers for all discounts",
                    title: "Invalid Discount Values",
                    type: "error",
                };
                this.snackBarService.openSnackBar(snackBarData);
            }

            this.editForm.markAllAsTouched();
        }
    }

    showSnackbar(message: string, type: "success" | "error"): void {
        this.snackBarService.openSnackBar({
            message: message,
            title: type === "success" ? "Success" : "Error",
            type: type,
        });
    }

    removeItemFromDataSource(saleItemId: number): void {
        if (this.discountInfo.sale_item) {
            this.discountInfo.sale_item = this.discountInfo.sale_item.filter(
                (item) => item.sale_item_id !== saleItemId
            );
            this.dataSource.data = this.discountInfo.sale_item;
            this.isFormDirty = true; // Mark form as dirty
        }
    }

    isDiscountValid(price: any): boolean {
        // Check for empty, non-number, or negative values
        return (
            price !== null &&
            price !== undefined &&
            price !== "" &&
            !isNaN(Number(price)) &&
            Number(price) >= 0
        );
    }

    // Format time_from and time_to for submission (e.g., "14:30:00")
    getFormattedTime(field: "time_from" | "time_to"): string | null {
        const hour = this.editForm.get(field + "_hour")?.value;
        const minute = this.editForm.get(field + "_minute")?.value;
        return hour && minute ? `${hour}:${minute}:00` : null;
    }
    getSelectedDays(): string {
        const weekDaysGroup = this.editForm.get("week_days") as FormGroup;
        return this.daysOfWeek
            .filter((day) => weekDaysGroup.get(day)?.value)
            .map((day) => day.toLowerCase())
            .join(",");
    }

    getSelectedWeekDays(): string[] {
        if (!this.editForm || !this.editForm.get("week_days")) {
            return [];
        }

        const weekDaysFormGroup = this.editForm.get("week_days") as FormGroup;
        const selectedDays: string[] = [];

        Object.entries(weekDaysFormGroup.value).forEach(([day, isChecked]) => {
            if (isChecked) {
                selectedDays.push(day);
            }
        });

        return selectedDays;
    }

    /**
     * Check if the discount field should be shown
     * Hide when: is_item_specific is checked (1) AND permitted_for is 1 (Item Discount)
     * Show in all other cases
     */
    shouldShowDiscountField(): boolean {
        const permittedForValue = this.editForm.get('permitted_for')?.value;
        const isItemSpecificValue = this.editForm.get('is_item_specific')?.value;

        // Hide discount field when is_item_specific is checked AND permitted_for is Item Discount
        if (isItemSpecificValue === 1 && permittedForValue === 1) {
            return false;
        }

        // Show in all other cases
        return true;
    }

    /**
     * Check if the promotion and grouping quantity fields should be shown
     * Hide when: permitted_for is 2 (Bill Discount)
     */
    shouldShowPromotionAndGroupingFields(): boolean {
        const permittedForValue = this.editForm.get('permitted_for')?.value;
        return permittedForValue !== 2;
    }

    /**
     * Check if the discount section (grouping quantity and discount fields) should be shown
     * Hide when: allow_editing is not equal to 0 (not "None") AND permitted_for is 1 (Item Discount)
     * Show in all other cases
     */
    shouldShowDiscountSection(): boolean {
        const permittedForValue = this.editForm.get('permitted_for')?.value;
        const allowEditingValue = this.editForm.get('allow_editing')?.value;

        // Hide when allow_editing is not "None" AND permitted_for is Item Discount
        if (allowEditingValue !== 0 && permittedForValue === 1) {
            return false;
        }

        // Show in all other cases
        return true;
    }

    /**
     * Check if the ITEMS tab should be disabled
     * Disable when: permitted_for is 2 (Bill Discount)
     */
    shouldDisableItemsTab(): boolean {
        const permittedForValue = this.editForm.get('permitted_for')?.value;
        return permittedForValue === 2;
    }
}
